<template>
  <v-row>
    <v-col cols="12" md="4">
      <div class="title">Organization</div>
      <v-divider />
      <v-card color="mt-2">
        <v-list class="grey lighten-4">
          <v-list-item-group v-model="selectedOrganization">
            <v-list-item
              v-for="organization in organizations"
              :key="`org${organization.slug}`"
              :value="organization.slug"
            >
              <v-list-item-content>
                <v-list-item-title
                  class="caption font-weight-bold"
                  v-text="organization.name"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-col>
    <v-col cols="12" md="4" v-if="selectedOrganization != null">
      <div class="title">Users</div>
      <v-divider />

      <v-text-field
        class="mt-2 elevation-2"
        label="Search by name"
        v-model="userQuery"
        v-if="users.length"
        filled
      ></v-text-field>

      <v-card class="scrollbar-md">
        <v-list v-if="filteredUsers.length" class="grey lighten-4">
          <v-list-item-group v-model="selectedUser">
            <v-list-item
              v-for="(user, i) in filteredUsers"
              :key="`user${i}`"
              :value="user.id"
            >
              <v-list-item-avatar>
                <v-img :src="user.profile_picture"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="user.full_name"></v-list-item-title>
                <v-list-item-subtitle
                  v-text="user.organization.name"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <vue-no-data v-else />
      </v-card>
    </v-col>
    <v-col md="4" cols="12" v-if="selectedUser">
      <div class="title">Permissions</div>
      <v-divider />
      <v-card class="mt-2">
        <div
          v-if="
            Object.keys(allConstants).length !== 0 &&
              orgRequestUserConstants.length
          "
          class="grey lighten-4 pa-3"
        >
          <div v-for="(item, i) in Object.keys(allConstants)" :key="`req${i}`">
            <v-row align="center">
              <v-col md="10">
                <input
                  type="checkbox"
                  :id="`checkbox-${i}`"
                  :checked="
                    orgUserConstants.filter(each =>
                      allConstants[item].includes(each)
                    ).length
                  "
                  @change="updateTitle(allConstants[item])"
                />
                <span class="subtitle-1 grey--text text--darken-4">
                  {{ capitalizeWord(item) }}
                </span>
              </v-col>
              <v-col md="2">
                <span class="font-weight-bold subtitle-2">
                  <v-icon
                    v-if="!showCommonDetails.includes(i)"
                    @click="showCommonDetails.push(i)"
                    v-text="$getIcon('mdiChevronDown')"
                  ></v-icon>
                  <v-icon
                    v-else
                    @click="
                      showCommonDetails = showCommonDetails.filter(
                        each => each !== i
                      )
                    "
                    v-text="$getIcon('mdiChevronUp')"
                  ></v-icon>
                </span>
              </v-col>
            </v-row>
            <div
              v-show="showCommonDetails.includes(i)"
              class="ml-6"
              v-for="(subItem, j) in allConstants[item]"
              :key="`${subItem}-${j}`"
            >
              <input
                type="checkbox"
                :checked="orgUserConstants.includes(subItem)"
                :key="`subCheckbox-${j}`"
                @change="updateSubItems(subItem)"
                class="ma-0"
              />
              <span class="subtitle-2 ml-1">
                {{ capitalizeWord(subItem) }}</span
              >
            </div>
          </div>
          <v-divider></v-divider>
          <v-row no-gutters>
            <v-col align="right" class="pt-2">
              <v-btn @click="assign" class="primary">Assign</v-btn>
            </v-col>
          </v-row>
        </div>
        <vue-no-data v-else />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
// this.$store.dispatch("shell/showSnackbar", {
//               text: `Successfully Assigned User Groups!`
//             });

import VueNoData from "@/components/common/layout_utils/VueNoData";
export default {
  components: { VueNoData },
  data() {
    return {
      organizations: [],
      selectedOrganization: null,
      selectedUser: null,
      users: [],
      userQuery: "",
      allConstants: {},
      orgUserConstants: [],
      orgRequestUserConstants: [],
      showCommonDetails: []
    };
  },
  created() {
    this.fetchOrganizations();
    this.fetchAllConstants();
  },
  computed: {
    filteredUsers() {
      return this.users.filter(obj => {
        return obj.full_name
          .toLowerCase()
          .includes(this.userQuery.toLowerCase());
      });
    },
    orgUser() {
      return `${this.selectedOrganization}--${this.selectedUser}`;
    }
  },
  methods: {
    capitalizeWord(item) {
      if (item) {
        let words = item.split("_");
        let capitalizedWords = [];
        words.forEach(element => {
          capitalizedWords.push(
            element[0].toUpperCase() + element.slice(1, element.length)
          );
        });
        return capitalizedWords.join(" ");
      }
    },
    updateSubItems(item) {
      if (this.orgUserConstants.includes(item)) {
        this.orgUserConstants = this.orgUserConstants.filter(
          each => each !== item
        );
      } else {
        this.orgUserConstants.push(item);
      }
    },
    updateTitle(permissions) {
      if (permissions.every(val => this.orgUserConstants.includes(val))) {
        this.orgUserConstants = this.orgUserConstants.filter(
          each => !permissions.includes(each)
        );
      } else if (
        this.orgUserConstants.filter(each => permissions.includes(each)).length
      ) {
        this.orgUserConstants = this.orgUserConstants.filter(
          each => !permissions.includes(each)
        );
      } else {
        this.orgUserConstants = this.orgUserConstants.filter(
          each => !permissions.includes(each)
        );
        this.orgUserConstants.push(...permissions);
      }
    },
    fetchOrganizations() {
      this.$axios
        .$get("api/v1/permission/scoped-organizations/")
        .then(response => {
          this.organizations = response;
        });
    },
    fetchUsers() {
      let url = `/api/v1/permission/organization-users/?organization_slug=${this.selectedOrganization}`;
      this.$axios.$get(url).then(response => {
        this.users = response;
      });
    },
    async fetchAllConstants() {
      try {
        const { data } = await this.$axios.get(
          "/api/v1/permission/all-constants/"
        );
        this.allConstants = data;
      } catch (error) {
        console.log(error); //eslint-disable-line
      }
    },
    async fetchOrgRequestUserConstants(orgId) {
      try {
        const { data } = await this.$axios.get(
          `/api/v1/permission/org-request-user-constants/?organization_slug=${orgId}`
        );
        this.orgRequestUserConstants = data;
      } catch (error) {
        console.log(error); //eslint-disable-line
      }
    },
    async fetchOrgUserConstants(orgId, userId) {
      try {
        const { data } = await this.$axios.get(
          `/api/v1/permission/org-user-constants/?organization_slug=${orgId}&user_id=${userId}`
        );
        this.orgUserConstants = data;
      } catch (error) {
        console.log(error); //eslint-disable-line
      }
    },
    async assign() {
      try {
        await this.$axios.post("/api/v1/permission/assign/", {
          permissions: this.orgUserConstants,
          target_user_id: this.selectedUser,
          target_organization_slug: this.selectedOrganization
        });
        this.$store.dispatch("shell/showSnackbar", {
          text: `Successfully assigned `
        });
      } catch (error) {
        if (this.$getProp(error, "response.data.message")) {
          this.$store.dispatch("shell/showSnackbar", {
            text: error.response.data.message,
            color: "red"
          });
        }
      }
    }
  },
  watch: {
    selectedOrganization(val) {
      if (val) {
        this.fetchUsers();
        this.fetchOrgRequestUserConstants(val);
      }
    },
    orgUser() {
      if (this.selectedOrganization && this.selectedUser) {
        this.fetchOrgUserConstants(
          this.selectedOrganization,
          this.selectedUser
        );
      }
    }
  }
};
</script>
